module.exports = __webpack_public_path__ + "img/nav-researches.13a1b4de.svg";